import request from '../utils/request';

export function postHospAndMobile (data){
    return request({
        url: "/wxmanager/person/bindHosp",
        method:'post',
        data,
    });
}
export function getPersonInit(){
    return request({
        url: "/wxmanager/person/hospInit",
        method:'post',
    });
}
export function postChangeInformed (data){
    return request({
        url: "/wxmanager/person/changeInformed",
        method:'post',
        data,
    });
}
export function postSmsByMobile (data){
    return request({
        url: "/wxmanager/person/pushSmsCodeByMobile",
        method:'post',
        data,
    })
}